"use client";

import { ChevronRight } from "@/components/icons/Chevron";
import { classed, clsx } from "@frend-digital/ui";
import { AccordionPrimitive } from "@frend-digital/ui/components";
import type { ComponentProps } from "react";
import styles from "./Accordion.module.css";

export const AccordionRoot = classed(AccordionPrimitive.Root, styles.accordionRoot, {
	variants: {
		topBorder: {
			false: styles.disableTopBorder,
			true: "",
		},
	},
	defaultVariants: {
		topBorder: true,
	},
});

export const AccordionItem = classed(AccordionPrimitive.Item, styles.accordionItem);

export const AccordionTrigger = classed(AccordionPrimitive.Trigger, styles.accordionTrigger);

export const AccordionContent = classed(AccordionPrimitive.Content, styles.accordionContent);

export const AccordionIndicator = ({ className }: { className?: string }) => (
	<div className={clsx(styles.chevron, className)}>
		<ChevronRight />
	</div>
);

export type AccordionItemType = { title: string; description: React.ReactNode };

export const Accordion = ({
	className,
	items,
	...props
}: {
	className?: string;
	items: AccordionItemType[];
} & ComponentProps<typeof AccordionRoot>) => {
	return (
		<AccordionRoot {...props} className={className}>
			{items.map((item) => (
				<AccordionItem key={item.title}>
					<AccordionTrigger>
						{item.title}
						<AccordionIndicator />
					</AccordionTrigger>
					<AccordionContent>{item.description}</AccordionContent>
				</AccordionItem>
			))}
		</AccordionRoot>
	);
};
